import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
import _imports_0 from '../../assets/pc/common/logox.png';
const _hoisted_1 = {
  class: "nav_right"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "text"
};
const _hoisted_5 = {
  class: "img"
};
const _hoisted_6 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: _normalizeClass($data.hasScroll || $data.showPopup || $data.isFree ? 'navLayout scrollNav' : 'navLayout'),
    onMouseenter: _cache[7] || (_cache[7] = (...args) => $options.mouseLeave && $options.mouseLeave(...args))
  }, [_cache[9] || (_cache[9] = _createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    alt: ""
  }, null, -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("button", {
    class: _normalizeClass($data.hasScroll || $data.showPopup || $data.isFree ? 'scrollBtn' : 'button'),
    style: _normalizeStyle($data.active == 'home' ? 'opacity:1' : ''),
    onClick: _cache[0] || (_cache[0] = $event => $options.navto('index')),
    onMouseenter: _cache[1] || (_cache[1] = (...args) => $options.mouseLeave && $options.mouseLeave(...args))
  }, " 首页 ", 38), _createElementVNode("div", null, [_createElementVNode("button", {
    class: _normalizeClass($data.hasScroll || $data.showPopup || $data.isFree ? 'scrollBtn' : 'button'),
    style: _normalizeStyle($data.active == 'normal' || $data.active == 'batch' || $data.active == 'delivery' ? 'opacity:1' : ''),
    onMouseenter: _cache[2] || (_cache[2] = (...args) => $options.mouseenter && $options.mouseenter(...args))
  }, " 解决方案 ", 38)]), _createElementVNode("button", {
    class: _normalizeClass($data.hasScroll || $data.showPopup || $data.isFree ? 'scrollBtn' : 'button'),
    style: _normalizeStyle($data.active == 'aboutUs' ? 'opacity:1' : ''),
    onClick: _cache[3] || (_cache[3] = $event => $options.navto('aboutUs')),
    onMouseenter: _cache[4] || (_cache[4] = (...args) => $options.mouseLeave && $options.mouseLeave(...args))
  }, " 关于我们 ", 38), _createElementVNode("button", {
    class: _normalizeClass($data.hasScroll || $data.showPopup || $data.isFree ? 'scrollBtn' : 'button'),
    style: _normalizeStyle($data.active == 'free' ? 'opacity:1' : ''),
    onClick: _cache[5] || (_cache[5] = $event => $options.navto('free')),
    onMouseenter: _cache[6] || (_cache[6] = (...args) => $options.mouseLeave && $options.mouseLeave(...args))
  }, " 免费使用 ", 38)])], 34), _withDirectives(_createElementVNode("div", {
    class: "popup",
    onMouseleave: _cache[8] || (_cache[8] = (...args) => $options.mouseLeave && $options.mouseLeave(...args))
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "popup_item",
      key: item.img,
      onClick: $event => $options.navto(item.name)
    }, [_createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(item.text), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
      class: _normalizeClass(item.active ? 'active_img' : 'nor_img'),
      src: item.img,
      alt: ""
    }, null, 10, _hoisted_6)])], 8, _hoisted_2);
  }), 128))], 544), [[_vShow, $data.showPopup]]), _createVNode(_component_van_overlay, {
    show: $data.showPopup
  }, null, 8, ["show"])], 64);
}